import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Dashboard } from './pages/Dashboard'
import { Tests } from './pages/Tests'
import { TestWizard } from './pages/TestWizard'
import { TestDetail } from './pages/TestDetail'
import { Runs } from './pages/Runs'
import { RunDetail } from './pages/RunDetail'
import { BrowserTasks } from './pages/BrowserTasks'
import { BrowserTaskDetail } from './pages/BrowserTaskDetail'
import { ScheduledTasks } from './pages/ScheduledTasks'
import { Personas } from './pages/Personas'
import { Settings } from './pages/Settings'
import { Workflows } from './pages/Workflows'
import { WorkflowDetail } from './pages/WorkflowDetail'
import { WorkflowBuilder } from './pages/WorkflowBuilder'
import { WorkflowRunDetail } from './pages/WorkflowRunDetail'
import { ChatWorkflowBuilder } from './pages/ChatWorkflowBuilder'
import { PlaywrightScripts } from './pages/PlaywrightScripts'
import { AuthenticationGuard } from './components/AuthenticationGuard'
import { ClerkApiProvider } from './components/ClerkApiProvider'
import { WebhookStatusProvider } from './contexts/WebhookStatusContext'
import { Toaster } from './components/ui/toaster'

function App() {
  return (
    <ClerkApiProvider>
      <WebhookStatusProvider>
        <AuthenticationGuard>
          <Layout>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/chat-workflow" element={<ChatWorkflowBuilder />} />
              <Route path="/authoring" element={<PlaywrightScripts />} />
              <Route path="/workflows" element={<Workflows />} />
              <Route path="/workflows/new" element={<WorkflowBuilder />} />
              <Route path="/workflows/:id" element={<WorkflowDetail />} />
              <Route path="/workflows/:id/edit" element={<WorkflowBuilder />} />
              <Route path="/tests" element={<Tests />} />
              <Route path="/tests/new" element={<TestWizard />} />
              <Route path="/tests/:id" element={<TestDetail />} />
              <Route path="/runs" element={<Runs />} />
              <Route path="/runs/:id" element={<RunDetail />} />
              <Route path="/workflow-runs/:id" element={<WorkflowRunDetail />} />
              <Route path="/browser-tasks" element={<BrowserTasks />} />
              <Route path="/browser-tasks/:id" element={<BrowserTaskDetail />} />
              <Route path="/scheduled-tasks" element={<ScheduledTasks />} />
              <Route path="/personas" element={<Personas />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
            <Toaster />
          </Layout>
        </AuthenticationGuard>
      </WebhookStatusProvider>
    </ClerkApiProvider>
  )
}

export default App
